'use strict';

var intentionToAssetColor = {};

exports.__exports = intentionToAssetColor;
//# sourceMappingURL=intentionToAssetColor.cjs.map
